import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./GuestUniversitySelect.styled";
import logo from "assets/logo.png";
import { universityService, University } from "services/universityService";

const GuestUniversitySelect: React.FC = () => {
  const navigate = useNavigate();
  const [universities, setUniversities] = useState<University[]>([]);
  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    universityService
      .getUniversities()
      .then(setUniversities)
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  const filtered = universities.filter((u) =>
    u.name.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (university: University) => {
    localStorage.setItem("guestMode", "true");
    localStorage.setItem("universityId", String(university.id));
    navigate("/home");
  };

  return (
    <S.Page>
      <S.TopBar>
        <S.BackButton onClick={() => navigate("/login")}>←</S.BackButton>
      </S.TopBar>

      <S.LogoWrap>
        <img src={logo} alt="지금 우리 학교는" />
      </S.LogoWrap>

      <S.TitleWrap>
        <S.Title>학교를 선택해주세요</S.Title>
        <S.Subtitle>로그인 없이 게스트로 둘러볼 학교를 선택하세요</S.Subtitle>
      </S.TitleWrap>

      <S.SearchWrap>
        <S.SearchIcon>🔍</S.SearchIcon>
        <S.SearchInput
          placeholder="학교 이름으로 검색..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />
      </S.SearchWrap>

      <S.List>
        {isLoading ? (
          <S.LoadingText>불러오는 중...</S.LoadingText>
        ) : filtered.length === 0 ? (
          <S.EmptyText>
            {query ? `"${query}"에 해당하는 학교가 없습니다.` : "등록된 학교가 없습니다."}
          </S.EmptyText>
        ) : (
          filtered.map((u) => (
            <S.UniversityCard key={u.id} onClick={() => handleSelect(u)}>
              <S.UniversityIcon>🏫</S.UniversityIcon>
              <S.UniversityName>{u.name}</S.UniversityName>
              <S.ArrowIcon>›</S.ArrowIcon>
            </S.UniversityCard>
          ))
        )}
      </S.List>
    </S.Page>
  );
};

export default GuestUniversitySelect;
